import React from 'react';
import { RoleAiMarketplace } from '@/components/ai/RoleAiMarketplace';

/**
 * Sponsor AI Tools Marketplace
 * Sponsors have 4 AI tool slots to customize their workflow
 */
export default function SponsorAiMarketplace() {
  return (
    <div className="mx-auto max-w-5xl">
      <RoleAiMarketplace
        role="sponsor"
        title="AI Tools Marketplace"
        description="Browse and activate AI tools to enhance your sponsorship workflow. Choose up to 4 tools to help with thank-you notes, impact tracking, and campaign management."
      />
    </div>
  );
}
